<template>
<div id="logout">

</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'logout',
  props: ['city', 'user', 'auth'],
  updated () {
    var formData = new FormData()
    formData.append('uid', this.user.uid)
    axios.post('https://crm.v-avtoservice.com/list/site-logout',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(function (response) {
      window.location.href = '/'
    })
      .catch(function () {
      })
  },
  created () {
    var formData = new FormData()
    formData.append('uid', this.user.uid)
    axios.post('https://crm.v-avtoservice.com/list/site-logout',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(function (response) {
      window.location.href = '/'
    })
      .catch(function () {
      })
  },
  mounted () {
    var formData = new FormData()
    formData.append('uid', this.user.uid)
    axios.post('https://crm.v-avtoservice.com/list/site-logout',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(function (response) {
      window.location.href = '/'
    })
      .catch(function () {
      })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/logout.vue